'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity, symbol, text, attributes, options) {
  var taggedSymbol = options.symbolTag ? '<' + options.symbolTag + '>' + symbol + '</' + options.symbolTag + '>' : symbol;
  text = (0, _htmlEscape2.default)(text);
  var taggedText = options.textWithSymbolTag ? '<' + options.textWithSymbolTag + '>' + text + '</' + options.textWithSymbolTag + '>' : text;

  if (options.usernameIncludeSymbol || !symbol.match(_atSigns2.default)) {
    return (0, _linkToText2.default)(entity, taggedSymbol + taggedText, attributes, options);
  } else {
    return taggedSymbol + (0, _linkToText2.default)(entity, taggedText, attributes, options);
  }
};

var _atSigns = require('./regexp/atSigns');

var _atSigns2 = _interopRequireDefault(_atSigns);

var _htmlEscape = require('./htmlEscape');

var _htmlEscape2 = _interopRequireDefault(_htmlEscape);

var _linkToText = require('./linkToText');

var _linkToText2 = _interopRequireDefault(_linkToText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];